import TabelToolBar from './components/TabelToolBar';
import ListTabel from './components/ListTabel';
import addBuyerDialog from './components/addBuyerDialog';
export default {
  components: {
    TabelToolBar: TabelToolBar,
    ListTabel: ListTabel,
    addBuyerDialog: addBuyerDialog
  },
  data: function data() {
    return {
      isShowAddBuyerDialog: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.Bus.on('onAdd', function () {
      _this.isShowAddBuyerDialog = true;
    });
  },
  methods: {
    closeAddBuyerDialog: function closeAddBuyerDialog() {
      this.isShowAddBuyerDialog = false;
    }
  }
};